/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.4.0
 * @since 1.0.0
 */
import styled from 'styled-components';

import { IAttrStyled } from '../../../../types/globalTypes';

/**
 * @description Styled Props for BlockWithIcon component wrapper.
 * @interface IWrapperStyleProps
 * @see IBlockWithIconProps
 *
 * @property{string} justifyContent Block positioning inside the container.
 */
interface IWrapperStyleProps {
    alignItems?: string;
    className?: string;
    justifyContent: string;
}

const BlockTextStyled = styled.div`
`;

const BlockContainerStyled = styled.div.attrs((props: IWrapperStyleProps) => ({
    'className': `block-with-icon ${props.className || ''}`,
    'data-block-with-icon': 'blockWithIcon',
}))<IWrapperStyleProps & IAttrStyled>`
    display: inline-flex;
    align-items: ${(props) => props.alignItems ? props.alignItems : 'center'};
    justify-content: ${(props) => props.justifyContent};

    .block-with-icon__icon-left,
    .block-with-icon__icon-right {
        display: flex;
    }
`;

export {
    BlockTextStyled,
    BlockContainerStyled,
};
